const JinjaIcon = ({ empty = false }: React.SVGProps<SVGSVGElement> & { empty?: boolean }) => (
  <p
    className={`ml-2 self-center justify-self-center rounded-md border px-1.5 py-0.5 text-xs font-medium transition-colors duration-200 hover:bg-opacity-10 ${
      empty
        ? "border-gray-400 text-gray-400 hover:bg-gray-400 group-hover:border-gray-400 group-hover:text-gray-400"
        : "border-blue-400 text-blue-400 hover:bg-blue-400 group-hover:border-blue-400 group-hover:text-blue-400"
    }`}
  >
    {empty ? "Need Input Variables?" : "jinja2"}
  </p>
);

export default JinjaIcon;
